import * as React from 'react';
import { ButtonInline } from 'ui';

export interface AddFiltersButtonProps {
  title?: string;
  onOpen: () => void;
}

export const AddFiltersButtonInline = (props: AddFiltersButtonProps) =>
  <ButtonInline onClick={props.onOpen}>
    {props.title}
  </ButtonInline>;
